import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBrands } from '../../Apis/content';

export const Brands = createAsyncThunk('brands', async (formData, { rejectWithValue }) => {
    try {
        const response = await getBrands(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const brandSlice = createSlice({
    name: 'brand',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearBrandStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(Brands.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Brands.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(Brands.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearBrandStatus } = brandSlice.actions;
export default brandSlice.reducer;

